import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

import { scrollToTop } from "@utils/scrollUtils";
import { navLinks } from "@constants/navLinks";
import { useScrollPosition } from "@hooks/useScrollPosition";
import { useWindowDimensions } from "@hooks/useWindowDimensions";
import useBlockScroll from "@hooks/useBlockScroll";

import { ReactComponent as FinderAiSignet } from "@images/branding/finder-ai-signet.svg";
import { ReactComponent as FinderAiText } from "@images/branding/finder-ai-text.svg";

import NavbarLink from "../NavbarLink/NavbarLink";
import MobileMenu from "../MobileMenu/MobileMenu";

import "./LandingNavbar.scss";

export const NAVBAR_OFFSET_TOP = 100;

const LandingNavbar = () => {
  const [isMobileMenuOpen, setOpenMobileMenu] = useState<boolean>(false);
  const { lock, unlock } = useBlockScroll();

  const { offset } = useScrollPosition();
  const { height } = useWindowDimensions();
  const { t } = useTranslation("landing");

  const openMenu = () => {
    setOpenMobileMenu(true);
    lock();
  };

  const closeMenu = () => {
    setOpenMobileMenu(false);
    unlock();
  };

  const isScrolled = offset >= height + NAVBAR_OFFSET_TOP;

  const classes = classNames("landing-navbar", { scrolled: isScrolled });

  return (
    <>
      <nav className={classes}>
        <div className="landing-navbar__content">
          <div className="navbar-logo-box">
            <button onClick={scrollToTop}>
              <FinderAiSignet className="navbar-signet" />
            </button>

            {!isScrolled && (
              <button onClick={scrollToTop}>
                <FinderAiText className="navbar-logo-text" />
              </button>
            )}
          </div>

          <div className="landing-navbar-links">
            {navLinks.map(({ tKey, sectionID, offsetTopDesktop, offsetTopMobile }, index) => {
              return (
                <NavbarLink
                  key={index}
                  sectionID={sectionID}
                  offsetTopDesktop={offsetTopDesktop}
                  offsetTopMobile={offsetTopMobile}
                >
                  {t(tKey as any)}
                </NavbarLink>
              );
            })}
          </div>

          <button onClick={openMenu} className="mobile-menu-btn">
            <img
              src="/images/icons/hamburger-icon.svg"
              alt="Hamburger icon - open mobile menu"
              height={24}
              width={24}
            />
          </button>
        </div>
      </nav>

      {isMobileMenuOpen && <MobileMenu onClose={closeMenu} />}
    </>
  );
};

export default LandingNavbar;
